<template>
    <FormSection title="Demographics Information" type="his-section" :full-height="false" :application-id="application">
        <template #content>
            <section class="py-3 pb-0 g-0">
                <div class="col-12 px-4 col-md-12 g-0">
                    <div class="col-12 py-2">
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Patient Information</b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-5 pe-lg-2">
                                <label id="patient_mrn" for="paient_mrn">
                                    Patient ID/MR Number
                                    <span class="text-danger">*</span>
                                </label>
                                <input
                                    id="patient_mrn"
                                    name="patient_mrn"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter MRN"
                                    v-model="patientDetails.medicalRecordNumber"
                                    @blur="v$.patientDetails.medicalRecordNumber.$touch"
                                />
                                <span v-if="v$.patientDetails.medicalRecordNumber.$error" class="field-invalid"
                                    >Patient ID/MR Number is required.</span
                                >
                            </div>
                            <div class="col-5 mt-4 pt-2">
                                <i> Last Patient ID/MR Number Used: {{ lastPatientMRN }}</i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name">
                                    <span class="badge me-1">A0500A</span> First Name
                                    <span class="text-danger">*</span>
                                </label>
                                <input
                                    id="Referral_First_Name"
                                    name="referral-first-name"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter First Name"
                                    class="form-control"
                                    v-model="patientDetails.firstName"
                                    @blur="v$.patientDetails.firstName.$touch"
                                />
                                <span v-if="v$.patientDetails.firstName.$error" class="field-invalid"
                                    >First Name is required.</span
                                >
                            </div>

                            <div class="form-group col-4 col-lg-3 pe-lg-2">
                                <label for="referral-middle-initial">
                                    <span class="badge me-1">A0500B</span>M.I.
                                </label>
                                <input
                                    name="referral-middle-initial"
                                    class="form-control"
                                    maxlength="1"
                                    type="text"
                                    placeholder="Enter M.I."
                                    v-model="patientDetails.middleInitial"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_Last_Name_Label" for="referral-last-name">
                                    <span class="badge">A0500C</span> Last Name
                                    <span class="text-danger">*</span>
                                </label>
                                <input
                                    id="Referral_Last_Name"
                                    class="form-control"
                                    name="referral-last-name"
                                    maxlength="50"
                                    placeholder="Enter Last Name"
                                    type="text"
                                    v-model="patientDetails.lastName"
                                    @blur="v$.patientDetails.lastName.$touch"
                                />
                                <span v-if="v$.patientDetails.lastName.$error" class="field-invalid"
                                    >Last Name is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_Last_Name_Label" for="referral-last-name">
                                    <span class="badge">A0500D</span> Suffix
                                </label>
                                <input
                                    id="Referral_Last_Name"
                                    name="referral-last-name"
                                    class="form-control"
                                    maxlength="50"
                                    placeholder="Enter Suffix"
                                    type="text"
                                    v-model="patientDetails.suffix"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="DOB">
                                    <span class="badge me-1">A0900</span> Date of Birth
                                    <span class="text-danger">*</span>
                                </label>
                                <DatePicker :getDate="getDate">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="DOB"
                                            type="text"
                                            class="form-control"
                                            placeholder="MM/DD/YYYY"
                                            autocomplete="off"
                                            :value="formatDateInput(patientDetails.dateOfBirth)"
                                            @change="(e) => getDate(e.target.value, e.target.name)"
                                            @blur="v$.patientDetails.dateOfBirth.$touch"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                        <span v-if="v$.patientDetails.dateOfBirth.$error" class="field-invalid"
                                            >Date of Birth is required.</span
                                        >
                                    </div>
                                </DatePicker>
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_Gender_Label" for="referral-gender">
                                    <span class="badge me-1">A0800</span> Sex
                                    <span class="text-danger">*</span>
                                </label>
                                <select
                                    id="Referral_Gender"
                                    class="form-select"
                                    name="referral-gender"
                                    v-model="patientDetails.gender"
                                    @blur="v$.patientDetails.gender.$touch"
                                >
                                    <option :value="null">Select Sex</option>
                                    <option v-for="(gender, index) of genderOptions" :key="index" :value="gender.value">
                                        {{ gender.name }}
                                    </option>
                                </select>
                                <span v-if="v$.patientDetails.gender.$error" class="field-invalid"
                                    >Sex is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="referral-social-security-number">
                                    <span class="badge me-1">A0600A</span> Social Security Number
                                </label>
                                <span>
                                    <div class="input-group d-flex w-100 flex-nowrap">
                                        <div class="flex-grow-1">
                                            <input
                                                name="referral-social-security-number"
                                                maxlength="9"
                                                minlength="9"
                                                class="form-control"
                                                type="text"
                                                placeholder="Enter SSN"
                                                v-number-only
                                                v-model="patientDetails.socialSecurityNumber"
                                            />
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="form-group col-4 col-lg-2 pe-lg-2">
                                <label for="referral-veteran"> Veteran </label>
                                <div class="input-group d-flex w-100 flex-nowrap">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text form-check p-1 pb-2">
                                            <input
                                                type="checkbox"
                                                class="form-check-input mx-1"
                                                id="veteran"
                                                v-model="isVeteranSelected"
                                            />
                                            <label class="form-check-label" for="veteran"></label>
                                        </div>
                                    </div>
                                    <div class="flex-shrink-1 flex-grow-1">
                                        <MultiSelectDropdown
                                            :options="veteranOptions"
                                            :disabled="!isVeteranSelected"
                                            :selected-items="patientDetails.veteran"
                                            v-on:selectedItemsUpdated="updateVeteranSelected"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-12 col-lg-4 pe-lg-2">
                                <label for="referral-mobile-number">
                                    Primary Phone Number
                                    <i
                                        class="fas fa-question-circle"
                                        v-tooltip="{
                                            title: `For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.`
                                        }"
                                    ></i>
                                    <span class="text-danger">*</span>
                                </label>
                                <PhoneNumber
                                    :enable-country="true"
                                    v-model:value="primaryNumber"
                                    v-model:extension="primaryExtension"
                                    v-model:type="primaryType"
                                    v-model:country="primaryCountry"
                                    :phone-type-options="phoneNumberTypeOptionsConfig"
                                    v-number-only
                                    v-on:blurredInput="
                                        v$.patientDetails.phoneNumbers[
                                            primaryNumberIndex(patientDetails?.phoneNumbers)
                                        ].$touch()
                                    "
                                />
                                <span
                                    v-if="
                                        v$.patientDetails.phoneNumbers[primaryNumberIndex(patientDetails.phoneNumbers)]
                                            ?.number.$error &&
                                        v$.patientDetails.phoneNumbers[primaryNumberIndex(patientDetails?.phoneNumbers)]
                                            ?.type.$error
                                    "
                                    class="field-invalid"
                                    >Phone Number and Phone Type is required.</span
                                >
                                <span
                                    v-else-if="
                                        v$.patientDetails.phoneNumbers[primaryNumberIndex(patientDetails.phoneNumbers)]
                                            ?.number.$error
                                    "
                                    class="field-invalid"
                                    >Phone Number is required.
                                </span>
                                <span
                                    v-else-if="
                                        v$.patientDetails.phoneNumbers[primaryNumberIndex(patientDetails?.phoneNumbers)]
                                            ?.type.$error
                                    "
                                    class="field-invalid"
                                    >Phone Type is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-4 pe-lg-2">
                                <label for="referral-mobile-number">
                                    Alternate Phone Number
                                    <i
                                        class="fas fa-question-circle"
                                        v-tooltip="{
                                            title: `For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.`
                                        }"
                                    ></i>
                                </label>
                                <PhoneNumber
                                    :enable-country="true"
                                    v-model:value="alternateNumber"
                                    v-model:extension="alternateExtension"
                                    v-model:type="alternateType"
                                    v-model:country="alternateCountry"
                                    :phone-type-options="phoneNumberTypeOptionsConfig"
                                    v-number-only
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="referral-email"> Email </label>
                                <input
                                    name="referral-email"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter Email Address"
                                    v-model="patientDetails.email"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_Agency_Branch_Label" for="agency-location-id">
                                    Agency Branch
                                    <span class="text-danger">*</span>
                                </label>
                                <select
                                    id="Referral_Agency_Branch"
                                    name="agency-location-id"
                                    class="form-select"
                                    v-model="patientDetails.locationId"
                                    @blur="v$.patientDetails.locationId.$touch()"
                                >
                                    <option value="">Select Branch</option>
                                    <option v-for="branch in branches" :value="branch.id" :key="branch.id">
                                        {{ branch.name }}
                                    </option>
                                </select>
                                <span v-if="v$.patientDetails.locationId.$error" class="field-invalid"
                                    >Agency Branch is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="referral-marital-status"> Marital Status </label>
                                <select
                                    class="form-select"
                                    name="marital-status"
                                    v-model="patientDetails.maritalStatus"
                                >
                                    <option value="0">Select Marital Status</option>
                                    <option v-for="status of MaritalStatuses" :value="status.value">
                                        {{ status.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-6 pe-lg-2 race-section">
                                <label for="referral-race">
                                    <span class="badge me-1">A1000</span> Race <span class="text-danger">*</span></label
                                >
                                <TagsInput
                                    class="tags-wrapper-hos"
                                    :data="RacesHospice"
                                    :tags="selectedRacesHospice"
                                    placeholder="Select Race"
                                    aria-autocomplete="off"
                                    :open-on-focus="true"
                                    v-on:updateTags="updateSelectedHospiceRaces"
                                    v-on:blurredInput="v$.patientDetails.race.$touch()"
                                ></TagsInput>
                                <span
                                    v-if="v$.patientDetails.race.$error || patientDetails.race.length === 0"
                                    class="field-invalid"
                                    >Race is required.</span
                                >
                            </div>
                            <div class="form-group col-6 pe-lg-2">
                                <label for="ethnicityHospice">
                                    <span class="badge me-1">A1000</span> Ethnicity
                                    <span class="text-danger">*</span></label
                                >
                                <TagsInput
                                    class="tags-wrapper-hos"
                                    :data="EthnicityHospice"
                                    :tags="selectedEthnicityHospice"
                                    placeholder="Select Ethnicity"
                                    aria-autocomplete="off"
                                    :open-on-focus="true"
                                    v-on:updateTags="updateSelectedHospiceEthnictiy"
                                    v-on:blurredInput="v$.patientDetails.hispanicEthnicityValues.$touch()"
                                />
                                <span v-if="v$.patientDetails.hispanicEthnicityValues.$error" class="field-invalid"
                                    >Ethnicity is required.</span
                                >
                            </div>
                        </div>
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Patient Primary Address</b>
                            </p>
                        </div>

                        <AddressForm
                            addressType="primaryAddress"
                            v-model:facility-id="patientDetails.primaryAddressFacilityTypeId"
                            :address="patientDetails.primaryAddress"
                            :is-primary-address="true"
                            :isRequired="true"
                            :provider-id="patientDetails?.providerId"
                            :show-code="true"
                            :is-address-validation-in-progress="isAddressValidationInProgress"
                        />
                        <div class="col-12 d-flex align-items-center">
                            <div class="me-2">
                                <button
                                    class="btn btn-xs btn-primary mb-2"
                                    @click="validateAddress()"
                                    v-if="
                                        !patientDetails.primaryAddress.latitude &&
                                        !patientDetails.primaryAddress.longitude
                                    "
                                >
                                    Validate Patient Primary Address
                                </button>
                            </div>
                            <div>
                                <h6
                                    :class="`${
                                        patientDetails.primaryAddress.isBypassed ? 'text-warning' : 'text-danger'
                                    } fw-bold`"
                                    v-if="
                                        !patientDetails.primaryAddress.latitude &&
                                        !patientDetails.primaryAddress.longitude
                                    "
                                >
                                    <i class="fas fa-exclamation-triangle"></i>
                                    <span>
                                        Address
                                        {{
                                            patientDetails.primaryAddress.isBypassed
                                                ? "Validation Bypassed"
                                                : "Not Validated"
                                        }}</span
                                    >
                                </h6>
                                <h6 class="text-success fw-bold" v-else>
                                    <i class="fas fa-check-circle"></i>
                                    <span> Address Validated </span>
                                </h6>
                            </div>
                        </div>
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Patient Visit Address</b>
                            </p>
                        </div>
                        <div class="w-100">
                            <div class="form-check custom-checkbox form-check-inline">
                                <input
                                    type="checkbox"
                                    id="visit-same-primary-address"
                                    class="form-check-input au-target"
                                    v-model="patientDetails.isVisitAddressSameAsPrimary"
                                    @change="handleSetVisitAddressSameAsPrimary()"
                                />
                                <label class="form-check-label" for="visit-same-primary-address">
                                    <span class="me-1">Same As Primary Address</span>
                                </label>
                            </div>
                        </div>
                        <AddressForm
                            v-if="!patientDetails.isVisitAddressSameAsPrimary"
                            address-type="Visit Address"
                            :address="patientDetails.visitAddress"
                            v-model:facility-id="patientDetails.visitAddressFacilityTypeId"
                            :is-primary-address="false"
                            :isRequired="true"
                            :showCode="true"
                            :facility-id="patientDetails.visitAddressFacilityTypeId"
                            :provider-id="patientDetails.providerId"
                            :isCountyRequired="true"
                        />
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Patient Mailing Address</b>
                            </p>
                        </div>
                        <div class="w-100">
                            <div class="form-check custom-checkbox form-check-inline">
                                <input
                                    type="checkbox"
                                    id="mailing-same-primary-address"
                                    class="form-check-input au-target"
                                    v-model="patientDetails.isMailingAddressSameAsPrimary"
                                    @change="handleSetMailingAddressSameAsPrimary()"
                                />
                                <label class="form-check-label" for="mailing-same-primary-address">
                                    <span class="me-1">Same As Primary Address</span>
                                </label>
                            </div>
                        </div>

                        <AddressForm
                            v-if="!patientDetails.isMailingAddressSameAsPrimary"
                            address-type="Mailing Address"
                            :address="patientDetails.mailingAddress"
                            v-model:facility-id="patientDetails.mailingAddressFacilityTypeId"
                            :provider-id="patientDetails.providerId"
                            :is-primary-address="false"
                            :isRequired="true"
                            :show-code="true"
                            :isCountyRequired="true"
                        />

                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center">
                                <span class="badge me-1">A1110</span>
                                <b class="me-2 sub-heading"> Language</b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="primary_language" for="primary_language"
                                    >What is your preferred language? <span class="text-danger">*</span></label
                                >
                                <TypeaheadInput
                                    placeholder="Enter Language..."
                                    :getData="getLanguageList"
                                    :value="selectedLanguage"
                                    v-on:valueChanged="updateLanguage"
                                    :init-value="selectedLanguage"
                                    v-on:blurredInput="v$.patientDetails.primaryLanguage.$touch"
                                ></TypeaheadInput>
                                <span v-if="v$.patientDetails.primaryLanguage.$error" class="field-invalid"
                                    >Primary Language is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="additional_language" for="additional_language"> Additional Language</label>
                                <TagsInput
                                    placeholder="Enter Language(s)"
                                    :getData="getLanguageList"
                                    :tags="selectedAdditionalLanguages"
                                    v-on:updateTags="updateAdditionalLanguage"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name">
                                    Auxiliary Aids Required</label
                                >
                                <input
                                    id="Referral_auxiliary_aid"
                                    name="referral-auxiliary_aid"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter Type"
                                    v-model="patientDetails.auxiliaryAids"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="interpreter" for="interpreter">
                                    Would you like an interpreter to communicate with a doctor or healthcare staff?<span
                                        class="text-danger"
                                        >*</span
                                    >
                                </label>
                                <div class="d-flex">
                                    <div v-for="interpreter of interpreters" class="me-4">
                                        <div
                                            :key="`${interpreter.value}-${interpreter.name}`"
                                            class="form-group form-check custom-radio"
                                        >
                                            <input
                                                type="radio"
                                                :id="`${interpreter.name}-${interpreter.value}`"
                                                class="form-check-input"
                                                :value="interpreter.value"
                                                v-model="patientDetails.interpreterResponse"
                                            />
                                            <label
                                                class="form-check-label"
                                                :for="`${interpreter.name}-${interpreter.value}`"
                                            >
                                                {{ interpreter.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="form-group col-12 col-lg-4 pe-lg-2"
                                    v-if="patientDetails.interpreter.includes(8)"
                                >
                                    <label for="other-interpreter"> Other Interpreter Description </label>
                                    <input
                                        class="form-control"
                                        maxlength="50"
                                        name="other-interpreter"
                                        type="text"
                                        v-model="patientDetails.otherInterpreter"
                                        placeholder="Enter Interpreter"
                                    />
                                </div>
                            </div>

                            <div class="form-group col-12 col-lg-4 pe-lg-2">
                                <label for="referral-race"> Tags</label>
                                <TagsInput
                                    :data="patientTags"
                                    :tags="selectedTags"
                                    placeholder="Start Typing..."
                                    aria-autocomplete="off"
                                    :open-on-focus="true"
                                    v-on:updateTags="updateSelectedTags"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script src="./DemographicsInformation.ts"></script>
